import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { CreatePasswordlessAccessModel } from '../models/create-passwordless-access';
import { EditPasswordlessAccessModel } from '../models/edit-passwordless-access';
import { PasswordlessAccess } from '../models/passwordless-access.model';

export class SetPasswordlessAccess {
    static readonly type = '[PasswordlessAccess] SetPasswordlessAccess';

    constructor(public payload: PasswordlessAccess) {}
}

export class UnsetPasswordlessAccess {
    static readonly type = '[PasswordlessAccess] UnsetPasswordlessAccess';
}

export class FetchPasswordlessAccess {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccess';

    constructor(public payload: string) {}
}

export class AddPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] AddPasswordlessAccesses';

    constructor(public payload: PasswordlessAccess[]) {}
}

export class FetchPasswordlessAccessSuccess {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccessSuccess';

    constructor(public payload: PasswordlessAccess) {}
}

export class FetchPasswordlessAccessFailure {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccessFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreatePasswordlessAccess {
    static readonly type = '[PasswordlessAccess] CreatePasswordlessAccess';

    constructor(public payload: CreatePasswordlessAccessModel) {}
}

export class CreatePasswordlessAccessSuccess {
    static readonly type = '[PasswordlessAccess] CreatePasswordlessAccessSuccess';

    constructor(public payload: PasswordlessAccess[]) {}
}

export class CreatePasswordlessAccessFailure {
    static readonly type = '[PasswordlessAccess] CreatePasswordlessAccessFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdatePasswordlessAccess {
    static readonly type = '[PasswordlessAccess] UpdatePasswordlessAccess';

    constructor(public payload: EditPasswordlessAccessModel) {}
}

export class UpdatePasswordlessAccessSuccess {
    static readonly type = '[PasswordlessAccess] UpdatePasswordlessAccessSuccess';

    constructor(public payload: PasswordlessAccess[]) {}
}

export class UpdatePasswordlessAccessFailure {
    static readonly type = '[PasswordlessAccess] UpdatePasswordlessAccessFailure';
}

export class DeletePasswordlessAccess {
    static readonly type = '[PasswordlessAccess] DeletePasswordlessAccess';

    constructor(public payload: string[]) {}
}

export class DeletePasswordlessAccessSuccess {
    static readonly type = '[PasswordlessAccess] DeletePasswordlessAccessSuccess';

    constructor(public payload: string[]) {}
}

export class DeletePasswordlessAccessFailure {
    static readonly type = '[PasswordlessAccess] DeletePasswordlessAccessFailure';
}

export class SendPasswordlessAccess {
    static readonly type = '[PasswordlessAccess] SendPasswordlessAccess';

    constructor(
        public payload: {
            accessIds: string[];
            subject: string;
            message: string;
        }
    ) {}
}

export class SendPasswordlessAccessSuccess {
    static readonly type = '[PasswordlessAccess] SendPasswordlessAccessSuccess';

    constructor(public payload: string) {}
}

export class SendPasswordlessAccessFailure {
    static readonly type = '[PasswordlessAccess] SendPasswordlessAccessFailure';
}

export class SetPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] SetPasswordlessAccesses';

    constructor(public payload: PasswordlessAccess[]) {}
}

export class FetchPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccesses';

    constructor(
        public payload: {
            pageSize: number;
            pageNumber: number;
            search: string;
        }
    ) {}
}

export class FetchPasswordlessAccessesSuccess {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccessesSuccess';

    constructor(public payload: PasswordlessAccess[]) {}
}

export class FetchPasswordlessAccessesFailure {
    static readonly type = '[PasswordlessAccess] FetchPasswordlessAccessesFailure';
}

export class ToggleSelectedPasswordlessAccess {
    static readonly type = '[PasswordlessAccess] ToggleSelectedPasswordlessAccess';

    constructor(public payload: string) {}
}

export class SelectFilteredPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] SelectFilteredPasswordlessAccesses';
}

export class DeselectSelectedPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] DeselectSelectedPasswordlessAccesses';
}

export class SearchPasswordlessAccesses {
    static readonly type = '[PasswordlessAccess] SearchPasswordlessAccesses';

    constructor(public payload: string) {}
}
